import { Button, Input, Select, Typography } from 'components';
import { useTranslations } from 'next-intl';
import { ChangeEvent, FC, MouseEvent, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Option } from 'types/Option';

import { updateCsvDelimiter, useUploadingContentFlow } from './_actions';

interface ISetCsvSeparatorFlow {
  updateCsvDelimiter: (delimiter: string) => void;
  useUploadingContentFlow: () => void;
}

const SetCsvSeparatorFlow: FC<ISetCsvSeparatorFlow> = ({
  updateCsvDelimiter,
  useUploadingContentFlow: uploadingContentFlow
}) => {
  const t = useTranslations();

  const optionsSeparator = [
    {
      value: '',
      label: t('ordering_form.delimiter.select_yours'),
      disabled: true
    },
    {
      value: ',',
      label: t('ordering_form.delimiter.comma')
    },
    {
      value: '&#09;',
      label: t('ordering_form.delimiter.tab')
    },
    {
      value: ';',
      label: t('ordering_form.delimiter.semicolon')
    },
    {
      value: '|',
      label: t('ordering_form.delimiter.pipe')
    },
    {
      value: '//',
      label: t('ordering_form.delimiter.double_slash')
    },
    {
      value: 'custom',
      label: t('ordering_form.delimiter.custom')
    }
  ];

  const [csvDelimiter, setCsvDelimiter] = useState(optionsSeparator?.at(1)?.value || '');
  const [customCsvDelimiter, setCustomCsvDelimiter] = useState('');

  const disabled = (csvDelimiter === 'custom' && !customCsvDelimiter) || !csvDelimiter;

  const submitDelimiter = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      const delimiter = csvDelimiter === 'custom' ? customCsvDelimiter : csvDelimiter;

      e.preventDefault();
      updateCsvDelimiter(delimiter);
      uploadingContentFlow();
    },
    [csvDelimiter, customCsvDelimiter, updateCsvDelimiter, uploadingContentFlow]
  );

  const handlerOnChangeSelect = ({ value }: Option) => setCsvDelimiter(value as string);

  const handlerOnChangeInput = (e: ChangeEvent<HTMLInputElement>) =>
    setCustomCsvDelimiter(e.target.value);

  return (
    <div className="ordering_form__content_frame rounded shadow-custom">
      <Typography variant="medium7xl" className="!mb-8 !mt-0 px-8 text-tertiary-100">
        {t('ordering_form.delimiter.header')}
      </Typography>
      <Typography variant="light3" className="!m-0 italic">
        {t('ordering_form.delimiter.explanation1')}
      </Typography>
      <Typography variant="light3" className="!my-4 italic">
        {t('ordering_form.delimiter.explanation2')}
      </Typography>
      <form className="ft__uploader__select">
        <div className="mb-4">
          <Select
            id="csv-delimiter-selector"
            selectedValue={csvDelimiter}
            onChange={handlerOnChangeSelect}
            options={optionsSeparator}
          />
        </div>
        {csvDelimiter == 'custom' && (
          <Input
            type="text"
            value={customCsvDelimiter}
            onChange={handlerOnChangeInput}
            placeholder={t('ordering_form.delimiter.delimiter')}
            className="mb-1"
          />
        )}
        <div className="flex justify-center">
          <Button className="m-0 mt-2" onClick={submitDelimiter} disabled={disabled}>
            {t('ordering_form.delimiter.select')}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default connect(null, { updateCsvDelimiter, useUploadingContentFlow })(SetCsvSeparatorFlow);
